import { isEmpty } from 'lodash'

type NavItem = {
  path: string
  label: string
  disableFor: string[]
}

export const getPrimaryNavList = (
  selectedOrg: Organization | null | undefined,
  user: User | null | undefined,
): NavItem[] => {
  if (!selectedOrg || isEmpty(user) || !user?.orgRoles) return []
  const role = user.orgRoles[selectedOrg.id]

  return [
    {
      path: 'home',
      label: 'Home',
      disableFor: [],
    },
    {
      path: 'mentoring',
      label: 'Mentoring',
      disableFor: ['member', 'mentor', 'editor'],
    },
    {
      path: 'library',
      label: 'Library',
      disableFor: ['member'],
    },
    {
      path: 'admin',
      label: 'Admin',
      disableFor: ['member', 'mentor', 'editor'],
    },
  ].filter(navItem => {
    if (!navItem.disableFor) return false

    return !navItem.disableFor.includes(role as string)
  })
}
